import { Stack, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import AppCustomIcon from '../../icon/AppIcon';
import { useAppTheme } from '../../theme/providers/AppThemeProvider';
import CAppSwitch from '../../../components/CAppSwitch';

const AppDarkModeSwitch = () => {
	const globalTheme = useAppTheme();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const handleToggleDarkMode = () => {
		globalTheme.changeTheme(globalTheme.theme === 'dark' ? 'light' : 'dark');
	};

	return (
		<Stack direction="row" spacing={1} alignItems="center" sx={{ marginRight: '10px', marginLeft: '10px' }}>
			<AppCustomIcon tag="ligthmode" color="primary" style={{ color: isMobile ? 'white' : '' }} />
			<CAppSwitch
				checked={globalTheme.theme === 'dark'}
				onChange={() => handleToggleDarkMode()}
				id="switch-darkmode"
			/>
			<AppCustomIcon tag="darkmode" color="primary" style={{ color: isMobile ? 'white' : '' }} />
		</Stack>
	);
};

export default AppDarkModeSwitch;
